/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import DateTimeFieldItemEdit from "./edit-item";

const DateTimeFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <DateTimeFieldItemEdit />
        </FieldListEditWrapper>
    );
};
DateTimeFieldEdit.displayName = "DateTimeFieldEdit";
export { DateTimeFieldEdit };
